import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, LOGEVENT, MODULE, PLATFORM_SIMULCAST_CHANNEL_CONFIG, TOAST_TYPES } from '../../framework/constant/constant';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import * as API from "../../framework/API/api";
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import BossDialog from '../../components/BossDialog';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import ToastNotification from '../../components/ToastNotification';

const SimulcastChannelConfigurationEditForm = () => {
    const lang = useTranslation();
    const navigate = useNavigate();
    const { SID } = useParams();
    const loc = useLocation();

    const blankDataItem = {
        Description: "",
        PrimaryChannel: {},
        Platform: {},
        Archive: false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showChannelPopup, setShowChannelPopup] = useState(false);
    const [gridChannelData, setGridChannelData] = useState([]);
    const [primaryChannels, setPrimaryChannels] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const blankChannelDataItem = { ChannelNumber: "", TransIdPrefix: "" };
    const [channelForm, setChannelForm] = useState(blankChannelDataItem);
    const [editIndex, setEditIndex] = useState(null);

    useEffect(() => {
        loadCombo();
        if (SID > 0) {
            loadEditData();
        }
    }, []);

    const loadCombo = async () => {
        const primaryChannelRes = await API.getDataLookup(ENTITYNAME.Channel, { query: ["Archive", "!=", true] });
        setPrimaryChannels(primaryChannelRes.data);
        let platformRes = Object.keys(PLATFORM_SIMULCAST_CHANNEL_CONFIG).map((x) => {
            return {
                _id: PLATFORM_SIMULCAST_CHANNEL_CONFIG[x],
                Description: x
            }
        })
        setPlatforms(platformRes)
    }
    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };
    const onChannelChange = (e) => {
        setChannelForm({ ...channelForm, [e.target.name]: e.target.value });
    };
    const loadEditData = async () => {
        let res = await API.getEntity(ENTITYNAME.SimulcastChannelConfig, parseInt(SID));

        if (res.success && res.data) {
            const groupData = res.data;
            setDataItem({
                ...groupData,
                Description: loc.state?.copy ? "Copy of " + groupData.Description : groupData.Description,
                PrimaryChannel: groupData.PrimaryChannel,
                Platform: groupData.Platform
            });
            const mappedChannels = (groupData.MappedChannels || []).map(lc => ({
                ChannelNumber: Number(lc.ChannelNumber),
                TransIdPrefix: lc.TransIdPrefix ?? ""
            }));
            setGridChannelData(mappedChannels);


        }
    };

    const isValid = () => {
        if (dataItem.Description == "" || dataItem.Description == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        return true;
    }
    const handleSubmit = async () => {
        if (!isValid()) return;
        console.log(channelForm)
        let finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Description: dataItem?.Description,
            PrimaryChannel: dataItem?.PrimaryChannel && Object.keys(dataItem?.PrimaryChannel).length > 0 ? {
                _id: dataItem?.PrimaryChannel?._id,
                FullChannelName: dataItem?.PrimaryChannel?.FullChannelName
            } : {},
            Platform: dataItem?.Platform && Object.keys(dataItem?.Platform).length > 0 ? {
                _id: dataItem?.Platform?._id,
                Description: dataItem?.Platform?.Description
            } : {},
            MappedChannels: gridChannelData?.map(x => ({
                ChannelNumber: Number(x.ChannelNumber),
                TransIdPrefix: x.TransIdPrefix
            })) || [],
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]],
        }
        if (loc.state.copy) {
            delete finalData._id;
            delete finalData.SID;
        }

        console.log(finalData)

        let res = await API.saveData(ENTITYNAME.SimulcastChannelConfig, finalData);
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.SIMULCAST_CHANNEL_CONFI, data: res.data, message: res.message };
        API.SaveLogs(logData);
        if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        } else {
            navigate(-1);
        }
    }
    const deleteSelectedValue = (item) => {
        setGridChannelData(prev => prev.filter(x => x._id !== item._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    };
    const editSelectedValue = (item) => {
        setChannelForm({ ChannelNumber: item.ChannelNumber, TransIdPrefix: item.TransIdPrefix, _id: item._id });
        setEditIndex(item.index);
        setShowChannelPopup(true);
    };

    const MyCommandCell = (props) => {
        return (
            <div className="mt-1 ml-1" style={{ display: "flex" }}>
                <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteSelectedValue(props.dataItem), () => { })} />
                <RoundButton icon="pencil" Title={lang.edit_button_tooltip} onClick={() => editSelectedValue({ ...props.dataItem, index: props.dataIndex })} />
            </div>
        )
    }
    const onSaveChannel = () => {

        if (!channelForm.ChannelNumber) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter Channel Number" });
            return;
        }
        const isDuplicate = gridChannelData.some((item, index) => {
            if (editIndex !== null && index === editIndex) return false;
            return Number(item.ChannelNumber) === Number(channelForm.ChannelNumber);
        });

        if (isDuplicate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Channel Number already exists" });
            return;
        }

        let updatedData = [...gridChannelData];

        if (editIndex !== null) {
            updatedData[editIndex] = { ...channelForm, ChannelNumber: Number(channelForm.ChannelNumber) };
        } else {
            updatedData.push({ ...channelForm, ChannelNumber: Number(channelForm.ChannelNumber) });
        }

        setGridChannelData(updatedData);
        setChannelForm(blankChannelDataItem);
        setEditIndex(null);
        setShowChannelPopup(false);
    };

    return (
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader
                    title={dataItem?.Description != "" ? dataItem?.Description : lang.simul_cast_channel_configuration_header}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate(-1)}
                />
                <div className="row">
                    <div className="col-6">
                        <label htmlFor="">{lang.description_label}*</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="Description"
                            value={dataItem.Description}
                            onChange={onChange}
                        />
                    </div>
                    <div className='col-6'>
                        <label>{lang.primary_channel_label} *</label>
                        <DropDownList
                            data={primaryChannels}
                            name="PrimaryChannel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.PrimaryChannel}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-6'>
                        <label>{lang.platform_label} *</label>
                        <DropDownList
                            data={platforms}
                            name="Platform"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Platform}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 mt-4">
                        <input
                            name="Archive"
                            type="checkbox"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label className="ml-1">{lang.archive}</label>
                    </div>
                </div>
                <div className="mt-4">
                    <AddRoundButton onClick={() => { setChannelForm(blankChannelDataItem); setEditIndex(null); setShowChannelPopup(true); }} />
                    <span className='float-right' style={{ marginTop: "16px" }}>{lang.channel_label}</span>
                    <Grid style={{ height: "80vh", margin: '0px 10px 40px 10px', overflow: "hidden" }} className="mt-2" data={gridChannelData}>
                        <GridColumn cell={MyCommandCell} width="70px" locked />
                        <GridColumn field="ChannelNumber" title={lang.channel_number_column} />
                        <GridColumn field="TransIdPrefix" title={lang.transmission_id_prefix_column} />
                    </Grid>
                </div>
            </div>
            {showChannelPopup && <BossDialog title={lang.channel_header} onClose={() => setShowChannelPopup(false)} width="700px">
                <EditPageHeader title="" onSubmit={onSaveChannel} onCancel={() => setShowChannelPopup(false)} />
                <div className="row mt-2">
                    <div className="col-6">
                        <label htmlFor="">{lang.channel_number_column} *</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="ChannelNumber"
                            value={channelForm.ChannelNumber}
                            onChange={onChannelChange}
                        />
                    </div>
                    <div className="col-6">
                        <label htmlFor="">{lang.transmission_id_prefix_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="TransIdPrefix"
                            value={channelForm.TransIdPrefix}
                            onChange={onChannelChange}
                        />
                    </div>
                </div>
            </BossDialog>}
        </div >
    )
}

export default SimulcastChannelConfigurationEditForm